import { Box, Grid, Skeleton } from "@mui/material";

export const CardSkeleton = () => {
  return (
    <Box sx={{ px: 4 }}>
      <Grid container spacing={1}>
        {Array.from(new Array(16)).map((_, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Skeleton
              animation="wave"
              sx={{
                width: 270,
                height: 150,
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};